import React, { useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";

const afterList = [
	"Voltar a dormir normalmente todas as noites",
	"Recuperar a confiança da sua família",
	"Parar de mentir para quem você ama",
	"Ver seu dinheiro durar e render mais",
	"Ter dias tranquilos sem recaída",
];

export const Transformation: React.FC = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const t = setTimeout(() => setVisible(true), 120);
		return () => clearTimeout(t);
	}, []);

	return (
		<section className="py-20 relative overflow-hidden">
			<div className="absolute inset-0 pointer-events-none">
				<div className="absolute -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 w-[680px] h-[680px] bg-gradient-to-tr from-accent/10 to-primary/6 rounded-full blur-3xl" />
			</div>

			<div className="container px-4 relative z-10">
				<header className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold">
						O que vai acontecer na sua{" "}
						<span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">
							vida
						</span>
					</h2>
				</header>

				<div className="max-w-2xl mx-auto">
					<div className="space-y-3">
						{afterList.map((item, i) => (
							<article
								key={i}
								role="listitem"
								className={`flex items-center gap-3 p-4 rounded-lg border bg-card/5 transition transform ${
									visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
								}`}
								style={{ transitionDelay: `${i * 60}ms` }}
							>
								<div className="w-10 h-10 rounded-full bg-accent/10 text-accent flex items-center justify-center flex-shrink-0">
									<CheckCircle className="w-5 h-5" />
								</div>
								<p className="text-sm text-muted-foreground text-left">
									{item}
								</p>
							</article>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};
